module.exports = { id: "facebook", url: "/build/app/img/symbols.svg#facebook", viewBox: "", toString: function() { return this.url; } };